import React, { Suspense, lazy } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

/* loader component for Suspense*/
import PageLoader from './components/Common/PageLoader';

import Base from './components/Layout/Base';
import BasePage from './components/Layout/BasePage';
// import BaseHorizontal from './components/Layout/BaseHorizontal';

/* Used to render a lazy component with react-router */
const waitFor = Tag => props => <Tag {...props}/>;

const SingleView = lazy(() => import('./components/SingleView/SingleView'));
const SubMenu = lazy(() => import('./components/SubMenu/SubMenu'));
const Login = lazy(() => import('./components/Login/Login'));
const RecuperarSenha = lazy(() => import('./components/Login/RedefinirSenha'));
const LoginProfessor = lazy(() => import('./components/Login/LoginProfessor'));
const Inicial = lazy(() => import('./components/Inicio/Inicial'));
const NovaEscola = lazy(() => import('./components/Escola/NovaEscola'));
const NovaAtividade = lazy(() => import('./components/Atividade/NovaAtividade'));
const AtividadeX = lazy(() => import('./components/Atividade/AtividadeX'));
const NovaTurma = lazy(() => import('./components/Turma/NovaTurma'));
const Turmas = lazy(() => import('./components/Turma/Turmas'));
const NovoAluno = lazy(() => import('./components/Aluno/NovoAluno'));
const DadosAluno = lazy(() => import('./components/Aluno/DadosAluno'));
const NovoProfessor = lazy(() => import('./components/Professor/NovoProfessor'));
const DadosProfessor = lazy(() => import('./components/Professor/DadosProfessor'));
const Escolas = lazy(() => import('./components/Escola/Escolas'));
const EscolasInternacionais = lazy(() => import('./components/Escola/EscolasInternacionais'));
const EscolasInativas = lazy(() => import('./components/Escola/EscolasInativas'));
const Atividades = lazy(() => import('./components/Atividade/Atividades'));
const Professores = lazy(() => import('./components/Professor/Professores'));
const Alunos = lazy(() => import('./components/Aluno/Alunos'));
const AlunoX = lazy(() => import('./components/Aluno/AlunoX'));
const EscolaX = lazy(() => import('./components/Escola/EscolaX'));
const DadosEscolaAdmin = lazy(() => import('./components/Escola/DadosEscolaAdmin'));
const DadosEscolaProfessor = lazy(() => import('./components/Escola/DadosEscolaProfessor'));
const DadosEscola = lazy(() => import('./components/Escola/DadosEscola'));
const TotalAlunos = lazy(() => import('./components/Aluno/TotalAlunos'));
const TrocarSenha = lazy(() => import('./components/User/TrocarSenha'));
const AprovarEscola = lazy(() => import('./components/Escola/Aprovar'));
const Senhas = lazy(() => import('./components/Senha/Senhas'));
const NovaSenha = lazy(() => import('./components/Desafios/NovaSenha'));
const ListaSenhas = lazy(() => import('./components/Desafios/ListaSenhas'));
const NovoRecado = lazy(() => import('./components/Mural/NovoRecado'));
const ListaRecados = lazy(() => import('./components/Mural/Recados'));
const MeusDados = lazy(() => import('./components/DadosEntidade/MeusDados'));
const MeusDadosAluno = lazy(() => import('./components/DadosEntidade/MeusDadosAluno'));
const MeusDadosProfessor = lazy(() => import('./components/DadosEntidade/MeusDadosProfessor'));
const RegistroProfessor = lazy(() => import('./components/Professor/Registrar'));
const acertaAlunos = lazy(() => import('./components/Apoio/acertaAlunos'));

// List of routes that uses the page layout
// listed here to Switch between layouts
// depending on the current pathname
const listofPages = [
    '/login',
    '/loginprofessor',
    '/recuperarsenha'
];
const listofPagesX = [
    '/dadosprofessor',
    '/dadosaluno',
    '/registroprofessor'
];


const Routes = ({ location }) => {
    const currentKey = location.pathname.split('/')[1] || '/';
    const timeout = { enter: 500, exit: 500 };

    // Animations supported
    //      'rag-fadeIn'
    //      'rag-fadeInRight'
    //      'rag-fadeInLeft'

    const animationName = 'rag-fadeIn'
    console.log(location)
    if(listofPages.indexOf(location.pathname) > -1) {
        return (
            // Page Layout component wrapper
            <BasePage>
                <Suspense fallback={<PageLoader/>}>
                    <Switch location={location}>
                    <Route path="/login" component={waitFor(Login)}/>
                    <Route path="/loginprofessor" component={waitFor(LoginProfessor)}/>
                    <Route path="/recuperarsenha" component={waitFor(RecuperarSenha)}/>
                    </Switch>
                </Suspense>
            </BasePage>
        )
    }
    if(location.pathname.includes('dadosprofessor') || location.pathname.includes('dadosaluno') || location.pathname.includes('registroprofessor')) {
        return (
            // Page Layout component wrapper
            <BasePage>
                <Suspense fallback={<PageLoader/>}>
                    <Switch location={location}>
                    <Route path="/dadosprofessor/:id" component={waitFor(DadosProfessor)}/>
                    <Route path="/dadosaluno/:id" component={waitFor(DadosAluno)}/>
                    <Route path="/registroprofessor" component={waitFor(RegistroProfessor)}/>
                    </Switch>
                </Suspense>
            </BasePage>
        )
    }
    else {
        return (
            // Layout component wrapper
            // Use <BaseHorizontal> to change layout
            <Base>
              <TransitionGroup>
                <CSSTransition key={currentKey} timeout={timeout} classNames={animationName} exit={false}>
                    <div>
                        <Suspense fallback={<PageLoader/>}>
                            <Switch location={location}>
                                <Route path="/inicial" component={waitFor(Inicial)}/>
                                <Route path="/senhas" component={waitFor(Senhas)}/>
                                <Route path="/novaescola" component={waitFor(NovaEscola)}/>
                                <Route path="/escolas" component={waitFor(Escolas)}/>
                                <Route path="/escolasinternacionais" component={waitFor(EscolasInternacionais)}/>
                                <Route path="/escolasinativas" component={waitFor(EscolasInativas)}/>
                                <Route path="/professores" component={waitFor(Professores)}/>
                                <Route path="/novoaluno" component={waitFor(NovoAluno)}/>
                                <Route path="/dadosescola" component={waitFor(DadosEscola)}/>
                                <Route path="/dadosescolaadmin" component={waitFor(DadosEscolaAdmin)}/>
                                <Route path="/dadosescolaprofessor" component={waitFor(DadosEscolaProfessor)}/>
                                <Route path="/alunos" component={waitFor(Alunos)}/>
                                <Route path="/alunox" component={waitFor(AlunoX)}/>
                                <Route path="/escolax" component={waitFor(EscolaX)}/>
                                <Route path="/totalalunos" component={waitFor(TotalAlunos)}/>
                                <Route path="/novoprofessor" component={waitFor(NovoProfessor)}/>
                                <Route path="/novaescola/:id" component={waitFor(NovaEscola)}/>
                                <Route path="/aprovarescola" component={waitFor(AprovarEscola)}/>
                                <Route path="/trocarsenha" component={waitFor(TrocarSenha)}/>
                                <Route path="/novasenha" component={waitFor(NovaSenha)}/>
                                <Route path="/listasenhas" component={waitFor(ListaSenhas)}/>
                                <Route path="/novorecado" component={waitFor(NovoRecado)}/>
                                <Route path="/listarecados" component={waitFor(ListaRecados)}/>
                                <Route path="/meusdados" component={waitFor(MeusDados)}/>
                                <Route path="/meusdadosaluno" component={waitFor(MeusDadosAluno)}/>
                                <Route path="/dadospessoaisprof" component={waitFor(MeusDadosProfessor)}/>
                                <Route path="/dadospessoaisalu" component={waitFor(MeusDadosAluno)}/>
                                <Route path="/acertaalunos" component={waitFor(acertaAlunos)}/>
                                <Redirect to="/login"/>
                            </Switch>
                        </Suspense>
                    </div>
                </CSSTransition>
              </TransitionGroup>
            </Base>
        )
    }
}

export default withRouter(Routes);
